import { useEffect, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PenSquare } from "lucide-react";
import { ProductReviewDialog } from "@/components/product/ProductReviewDialog";
import { HomeReviewCarousel } from "@/components/home/HomeReviewCarousel";

export function SocialProofSection() {
  const [showForm, setShowForm] = useState(false);
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get("review") === "brainCharge") setShowForm(true);
  }, []);

  return (
    <section id="reviews" className="scroll-mt-24 bg-background px-4 pb-16 pt-5 md:pt-7" aria-labelledby="reviews-heading">
      <div className="container max-w-6xl mx-auto">
        <h2 id="reviews-heading" className="sr-only">Customer reviews</h2>

        <HomeReviewCarousel onWriteReview={() => setShowForm(true)} />

        <div className="mb-8 mt-10 space-y-3 text-center md:mt-12">
          <Badge variant="outline" className="bg-primary/5 text-primary border-primary/20 rounded-full px-4 py-1">
            Customer Reviews
          </Badge>
          <p className="text-2xl font-bold text-foreground md:text-4xl">
            Real People. <span className="text-primary">Real Experience.</span>
          </p>
          <p className="text-sm md:text-base text-muted-foreground max-w-2xl mx-auto">
            Honest feedback—positive or critical—helps us improve and helps future customers make informed decisions.
          </p>
          <p className="text-xs md:text-sm text-muted-foreground/80 max-w-2xl mx-auto">
            Proton Health Labs reserves 5% of the funds we actually receive from each sale, after payment processing fees, for future charitable impact. No recipient has been selected yet; we’ll share updates when contributions are made.
          </p>
        </div>

        <div className="text-center">
          <Button
            size="lg"
            onClick={() => setShowForm(true)}
            className="bg-primary hover:bg-primary/90 text-primary-foreground font-bold shadow-xl shadow-primary/25 rounded-full px-8"
          >
            <PenSquare className="mr-2 h-5 w-5" />
            Write a Review
          </Button>
        </div>
        <ProductReviewDialog open={showForm} onOpenChange={setShowForm} trigger={null} />
      </div>
    </section>
  );
}
